import React from 'react';
import PercentageInputComponent from './PercentageInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}
const PercentageInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  switch (null) {
    default:
      return <PercentageInputComponent question={question} />;
  }
};

export default PercentageInputPicker;
